import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Tailwind-based prose styling for rendered markdown (headings, tables, code, lists)
const proseClasses =
    "max-w-none text-sm leading-relaxed text-content " +
    "[&_h1]:text-2xl [&_h1]:font-semibold [&_h1]:mt-4 [&_h1]:mb-3 " +
    "[&_h2]:text-xl [&_h2]:font-semibold [&_h2]:mt-4 [&_h2]:mb-2 " +
    "[&_h3]:text-lg [&_h3]:font-semibold [&_h3]:mt-3 [&_h3]:mb-2 " +
    "[&_p]:my-2 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:my-1 " +
    "[&_a]:text-primary [&_a]:underline " +
    "[&_code]:bg-surface-muted [&_code]:px-1 [&_code]:rounded [&_pre]:bg-surface-muted [&_pre]:p-3 [&_pre]:rounded [&_pre]:overflow-auto " +
    "[&_table]:border-collapse [&_table]:my-3 [&_th]:border [&_th]:border-border [&_th]:px-2 [&_th]:py-1 [&_th]:bg-surface-light " +
    "[&_td]:border [&_td]:border-border [&_td]:px-2 [&_td]:py-1 " +
    "[&_blockquote]:border-l-4 [&_blockquote]:border-border [&_blockquote]:pl-3 [&_blockquote]:text-body";

const MarkdownView = ({ url }) => {
    const [content, setContent] = useState("");
    const [error, setError] = useState(false);

    useEffect(() => {
        let isActive = true;
        setError(false);
        fetch(url)
            .then((res) => {
                if (!res.ok) throw new Error("Failed to load document");
                return res.text();
            })
            .then((text) => isActive && setContent(text))
            .catch(() => isActive && setError(true));
        return () => { isActive = false; };
    }, [url]);

    if (error) return <p className="text-danger text-sm">Unable to load this document.</p>;

    return (
        <div className={proseClasses}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </div>
    );
};

export default MarkdownView;
